<ng-container *ngIf="showUsd !== 'only'">
    <span class="tez-value">{{ displayValue | number: '1.0-' + (decimals || '6') }}</span>
    <fa-icon [icon]="[$any('fac'), $any('tez')]"></fa-icon>
</ng-container>
<span class="usd-value secondary-text fw-light" *ngIf="usdPrice | async; let price">({{ price | currency: 'USD':'symbol' }})</span>
